// Third party library imports
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

// Zopup library imports
import { StorageKey, StorageService } from '@zopup/zop-shared';
import { UserDto } from '@zopup/zop-types';
import {
    ZopCardComponent,
    ZopPageConfig
} from '@zopup/zop-ux-core';

// Internal project imports
import { UserProfilePageConfig } from './user-profile-page-config';
@Component({
    selector: 'zopup-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrl: './user-profile.component.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        ZopCardComponent,
    ]
})
export class UserProfileComponent implements OnInit {
    pageConfig!: ZopPageConfig;
    selectedUser: UserDto | undefined;

    constructor(private _storageService: StorageService) {}

    ngOnInit() {
        this.pageConfig = UserProfilePageConfig;
        this.selectedUser = this._storageService.getItem<UserDto>(
            StorageKey.user
        );
        if (!this.selectedUser) {
            // Handle case where user is not logged in or data not available
            console.warn('User data not found in storage');
        }
    }
}
